module.exports = __webpack_public_path__ + "static/media/staffSubImg1.3fcee70c.png";